import { combineReducers} from 'redux'
import associatedCamera from './associatedCameraReducer'
import auth from './authReducer'
import captcha from './captchaReducer'
import calendar from './calendarReducer'
import camera from './cameraReducer'
import compare from './compareReducer'
import compareCalendar from './compareCalendarReducer'
import compareImage from './compareImageReducer'
import currentImage from './currentImageReducer'
import log from './logReducer'
import navigation from './navigationReducer'
import panWindow from './panWindowReducer'
import password from './passwordReducer'
import photoDimensions from './photoDimensionsReducer'
import photoViewer from './photoViewerReducer'
import weather from './weatherReducer'
import user from './userReducer'
import settings from './settingsReducer'
import videoEdit from './videoEditReducer'
import procoreEmbed from './procoreEmbedReducer'
import { LOGOUT_RESPONSE, FORCED_OUT } from '../actions/actionTypes'

const appReducer = combineReducers({
    auth,
    associatedCamera,
    captcha,
    calendar,
    camera,
    compare,
    compareCalendar,
    compareImage,
    currentImage,
    log,
    navigation,
    panWindow,
    password,
    photoDimensions,
    photoViewer,
    weather,
    user,
    settings,
    videoEdit,
    procoreEmbed
})

// Reset every slice to its initial state on logout / forced sign-out so a
// subsequent login can't briefly show the previous user's projects/cameras
// while the API response is in flight. The auth reducer's own LOGOUT_RESPONSE
// handler still runs (clearing localStorage tokens) because the action is
// still dispatched through child reducers.
const rootReducer = (state, action) => {
    if (action.type === LOGOUT_RESPONSE || action.type === FORCED_OUT) {
        state = undefined
    }
    return appReducer(state, action)
}

export default rootReducer
